import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-section-mobile-download',
  templateUrl: './content-section-mobile-download.component.html',
  styleUrls: ['./content-section-mobile-download.component.css']
})
export class ContentSectionMobileDownloadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
